import { render, staticRenderFns } from "./PrefixMaintenance.vue?vue&type=template&id=08a9d58a&scoped=true&"
import script from "./PrefixMaintenance.vue?vue&type=script&lang=js&"
export * from "./PrefixMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9d58a",
  null
  
)

export default component.exports